
/*
 *   File : dashboard.js
 *   Author URI : https://evoqins.com
 *   Description : Dashboard for family
 *   Integrations : null
 *   Version : v1.1
 */

// import packages
import { useState, useEffect, useRef } from "react";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

// import components
import { CustomTab } from "../../../../Components/Tab";
import { FamilyRequestCard } from "../../../../Components/Cards";
import { InviteMemberModal, FamilyJoiningRequest, DeleteMember } from "../../../../Components/Modal";
import { CustomLoader, EmptyScreen } from "../../../../Components/Other";

// import service
import APIService from "../../../../Services/api-service";
import FamilyMemberDetail from "./family-detail";


const TAB_DATA = ['Family members', 'Manage request'];



export default function FamilyDashboard(props) {
    const [apiLoader, setApiLoader] = useState(true);
    const [tabIndex, setTabIndex] = useState(1);
    const [openInviteModal, setOpenInviteModal] = useState(false);
    const [requestStatus, setRequestStatus] = useState(false);
    const [openRequestModal, setOpenRequestModal] = useState(false);
    const [familyMembers, setFamilyMembers] = useState({});
    const [requestedList, setRequestedList] = useState([]);
    const [tabLoader, setTabLoader] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [removing, setRemoving] = useState(false);
    const [showDetail, setShowDetail] = useState(null);

    useEffect(() => {
        if (openConfirmModal === true) {
            const modal = new Modal(document.getElementById("delete-member"), {});
            modal.show();
        }
    }, [openConfirmModal]);



    useEffect(() => {
        if (tabIndex === 1) {
            _getFamilyMembers();
        } else {
            _getRequest();
        }
    }, [tabIndex]);

    useEffect(() => {
        if (openInviteModal === true) {
            _openInviteModal();
        }
    }, [openInviteModal]);

    useEffect(() => {
        if (openRequestModal === true) {
            _openRequestModal();
        }
    }, [openRequestModal]);

    // open invite modal
    function _openInviteModal() {
        const modal = new Modal(document.getElementById("invite-modal"), {});
        modal.show();
    }

    function _openRequestModal() {
        const modal = new Modal(document.getElementById("family-request-status"), {});
        modal.show();
    }

    function _handleRequestCallBack(status) {
        setRequestStatus(status);
        setOpenRequestModal(true);
    }

    // handle tab change
    function _handleTabSelect(value) {
        setTabIndex(value);
    }

    // handle button click
    function _handleInviteButton() {
        setOpenInviteModal(true);
    }

    // handle modal close callback
    function _closeInviteModal() {
        setOpenInviteModal(false);
    }

    function _handleRequestModal() {
        setOpenRequestModal(false);
        _getRequest();
    }

    function _openConfirmModal(id) {
        setSelectedMember(id);
        setOpenConfirmModal(true);
    }

    function _closeConfirmModal() {
        setSelectedMember(null);
        setOpenConfirmModal(false);
    }
    // handle invite 
    function _handleInvite() {
        setOpenInviteModal(false);
        _getRequest();
        setTabIndex(2);
    }


    // API - get family members
    function _getFamilyMembers() {
        setTabLoader(true);
        let url = 'family/get-all';
        const request = {
            customer_id: props.userId
        }
        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setFamilyMembers(response.data);
            } else {
                setFamilyMembers({});
            }
            setApiLoader(false);
            setTabLoader(false);
            setOpenConfirmModal(false);
        })
    }

    // API - get Family requests
    function _getRequest() {
        setTabLoader(true);
        let url = 'family/list-request';
        const request = {
            customer_id: props.userId
        }

        APIService(true, url, request).then((response) => {
            if (response.status_code === 200) {
                setRequestedList(response.data);
            } else {
                setRequestedList([]);
            }
            setTabLoader(false);
        })
    }

    // API - remove family member
    async function _removeMember() {
        setRemoving(true);
        let status = false;
        let url = 'family/remove';
        let payload = JSON.stringify({
            family_detail_id: selectedMember
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success('Removed member from family');
                _getFamilyMembers();
                status = true;
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setRemoving(false);
        })
        return status;
    }

    const FamilyInfo = (props) => {
        return (
            <div className="bg-light-powder-blue border-radius-16px padding-24px-all">
                <h4 className="e-poppins-medium e-font-14 line-height-20px color-outer-space">{props.heading}</h4>
                <p className={`${props.descriptionColor} e-poppins-bold e-font-24 mb-0`}>{props.rupee && <span className="e-inter-bold">₹</span>} {props.description}</p>
            </div>
        )
    }

    return (
        <>
            {
                showDetail ?
                    <FamilyMemberDetail profileData={props.customer_info} navigateBack={() => setShowDetail(null)} id={showDetail} />
                    :
                    apiLoader === true ? (
                        <div className='h-80vh '>
                            <CustomLoader />
                        </div>
                    ) : (
                        <>


                            {/* Tabs */}
                            <div className="row mt-4">
                                <div className="col-sm-8 ">
                                    <CustomTab data={TAB_DATA}
                                        wrapperClass={'gap-16px'}
                                        index={tabIndex}
                                        className="px-0 padding-10px-tb e-order-tab mb-4"
                                        onSelectTab={_handleTabSelect} />
                                </div>
                                <div className="col-sm-4 text-sm-end">
                                    <button className="border-radius-8px padding-8px-tb border-all border-primary-color outline-none  e-poppins-medium e-font-14 color-primary-color bg-cards align-items-center"
                                        onClick={_handleInviteButton}>
                                        <img src={require('../../../../Assets/Images/Family/invite-family.png')}
                                            className="w-24px h-24px me-2" />
                                        Invite family member
                                    </button>
                                </div>
                            </div>

                            {/* Tab data */}
                            {
                                tabLoader === true ? (
                                    <div className='h-80vh '>
                                        <CustomLoader />
                                    </div>
                                ) :
                                    <>
                                        {
                                            tabIndex === 1 ?
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p className="color-jett-black-dark e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3 me-3 margin-block-end-0">
                                                            Family investment summary
                                                        </p>
                                                    </div>
                                                    {
                                                        familyMembers?.members?.length > 0 ?
                                                            <>
                                                                {
                                                                    familyMembers.members.map((item, key) => {
                                                                        return (
                                                                            <div className="col-12 mt-3" key={key}>
                                                                                <FamilyRequestCard data={item} type={1}
                                                                                    showDetail={() => setShowDetail(item.family_detail_id)}
                                                                                    openDeleteModal={_openConfirmModal} />
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                            :
                                                            <EmptyScreen title="No family members added" />
                                                    }

                                                </div>
                                                :
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p className="color-jett-black-dark e-poppins-semi-bold e-font-16 line-height-24px mt-4 mb-3 me-3 margin-block-end-0">
                                                            New request
                                                        </p>
                                                    </div>
                                                    {
                                                        requestedList.length > 0 ?
                                                            requestedList.map((item, key) => {
                                                                return (
                                                                    <div className="col-12 mt-3" key={key}>
                                                                        <FamilyRequestCard data={item}
                                                                            type={2}
                                                                            showDetail={() => setShowDetail(item.family_detail_id)}
                                                                            handleJoiningRequestCallBack={_handleRequestCallBack} />
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            <EmptyScreen title="No request found" />
                                                    }

                                                </div>
                                        }
                                    </>
                            }
                        </>
                    )
            }
            {
                openInviteModal === true &&
                <InviteMemberModal sendInvite={_handleInvite}
                    id={props.userId}
                    close={_closeInviteModal}
                />
            }
            {
                openRequestModal === true &&
                <FamilyJoiningRequest status={requestStatus}
                    close={_handleRequestModal} />
            }
            {
                openConfirmModal === true &&
                <DeleteMember confirmationText="Are you sure you want to remove this member from family?"
                    loading={removing}
                    updateList={_getFamilyMembers}
                    handleConfirmation={_removeMember}
                    close={_closeConfirmModal} />
            }
        </>
    )
}